import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
export var ResourceNode = function ResourceNode() {
  _classCallCheck(this, ResourceNode);

  this.resource = void 0;
  this.writer = void 0;
  this.readerCount = 0;
  this.version = void 0;
};
//# sourceMappingURL=ResourceNode.js.map